import React, { useEffect } from 'react';
import {
  useParams,
} from 'react-router-dom';

import useHttpStatus from '~/commons/hooks/useHttpStatus';
import Header from '../../layout/Header.jsx';
import PageHttp from '~/commons/components/PageHttp.jsx';
import FormPlayer from '../../forms/FormPlayer.jsx';

const PagePlayer = () => {
  const { _id } = useParams();
  const [res, req] = useHttpStatus();

  useEffect(() => {
    if (_id !== 'new') {
      req({ url: `/api/site/players/${_id}` });
    }
  }, [_id]);

  const breadcrumb = _id === 'self' ? [] : [
    { to: '../', children: 'Players' },
  ];

  return _id === 'new' ? (
    <>
      <Header breadcrumb={breadcrumb}>New Player</Header>
      <FormPlayer />
    </>
  ) : (
    <PageHttp res={res}>
      {(doc) => (
        <>
          <Header breadcrumb={breadcrumb}>Edit</Header>
          <FormPlayer
            player={doc}
          />
        </>
      )}
    </PageHttp>
  );
};

export default PagePlayer;
